import * as types from './types'
import { FundGroup } from 'app/models/fund-group'

export const loadFundGroupsAction = (groups: FundGroup[]) => ({
  type: types.LOAD_FUND_GROUPS,
  payload: groups,
})

/** Replace ONE fund manager's groups, leaving other managers' groups in the store untouched. */
export const loadFundGroupsForManagerAction = (fundManagerId: string, groups: FundGroup[]) => ({
  type: types.LOAD_FUND_GROUPS_FOR_MANAGER,
  payload: { fundManagerId, groups },
})

export const upsertFundGroup = (group: FundGroup) => ({
  type: types.UPSERT_FUND_GROUP,
  payload: group,
})

export const removeFundGroup = (id: string) => ({
  type: types.REMOVE_FUND_GROUP,
  payload: id,
})

export const setFundGroupsLoading = (isLoading: boolean) => ({
  type: types.SET_FUND_GROUPS_LOADING,
  payload: isLoading,
})
